import React from "react";

type Props = {
  title: string;
  image: string;
  onClick?: () => void;
  availableCount?: number;
};

const ResearchCard = ({ title, image, onClick, availableCount }: Props) => {
  const hasAvailable = typeof availableCount === "number" && availableCount > 0;

  return (
    <div
      className="research-card button position-relative"
      onClick={onClick}
      style={{
        filter: "drop-shadow(2.89px 11.56px 0px rgba(0, 0, 0, 0.25))",
      }}
    >
      {/* Card Background Frame */}
      <div className="research-card-frame">
        {hasAvailable && (
          <div className="research-card-available-badge">
            {availableCount} available
          </div>
        )}
        {/* Image Container */}
        <div className="research-card-image-container">
          <img
            src={image}
            alt={title}
            className="research-card-image"
          />
        </div>

        {/* Title */}
        <div className="research-card-title-container">
          <h3 className="research-card-title dark-yellow fw-semibold">
            {title}
          </h3>
        </div>
      </div>

      <style>{`
        .research-card {
          width: 349px;
          height: 339px;
          position: relative;
          transition: transform 0.2s;
          background-image: url('/assets/images/backgrounds/research-card.svg');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        .research-card:hover {
          transform: translateY(-4px);
        }

        .research-card-frame {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 10px;
          padding-top: 18px;
        }

        .research-card-available-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          background: linear-gradient(135deg, #f7d17b 0%, #be863e 100%);
          color: #1e1208;
          border-radius: 12px;
          padding: 6px 12px;
          font-size: 14px;
          font-weight: 800;
          box-shadow: 0 4px 10px rgba(0,0,0,0.35);
        }

        /* Image Container */
        .research-card-image-container {
          width: 100%;
          max-width: 229px;
          border: 2px solid #be863e;
          border-radius: 6px;
          overflow: hidden;
          background: linear-gradient(135deg, #1a4d6d 0%, #2d5a7b 100%);
        }

        .research-card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Title */
        .research-card-title-container {

          width: 235px;
          text-align: center;
        }

        .research-card-title {
          font-size: 32.677px;
          text-shadow: 0px 4.085px 0px #000000;
          margin: 0;
          white-space: pre-wrap;
        }

        @media (max-width: 768px) {
          .research-card {
            width: 100%;
            height: auto;
            aspect-ratio: 349 / 339;
            min-height: 160px;
          }

          .research-card-frame {
            padding-top: 10px;
            gap: 6px;
          }

          .research-card-image-container {
            max-width: 60%;
          }

          .research-card-title-container {
            width: 85%;
          }

          .research-card-title {
            font-size: 18px;
            text-shadow: 0px 2px 0px #000000;
          }

          .research-card-available-badge {
            top: 6px;
            right: 6px;
            padding: 4px 8px;
            font-size: 10px;
            border-radius: 8px;
          }
        }

        @media (max-width: 480px) {
          .research-card {
            min-height: 140px;
          }

          .research-card-frame {
            padding-top: 8px;
            gap: 4px;
          }

          .research-card-title {
            font-size: 14px;
          }

          .research-card-available-badge {
            font-size: 9px;
            padding: 3px 6px;
          }
        }
      `}</style>
    </div>
  );
};

export default ResearchCard;
